import React from 'react'
import styled from 'styled-components'
import FinanceCard from '../foundation/FinanceCard'

interface Props {
  title: string
  description: string
  status?: 'live' | 'planned'
  onClick?: () => void
  disabled?: boolean
}

const Button = styled.button<{ $disabled?: boolean }>`
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.65 : 1)};
`

const Planned = styled.div`
  margin-top: 10px;
  color: #0f766e;
  font-size: 12px;
  font-weight: 600;
`

const FinanceReportCard: React.FC<Props> = ({
  title,
  description,
  status = 'live',
  onClick,
  disabled,
}) => (
  <Button
    type="button"
    onClick={() => !disabled && onClick?.()}
    $disabled={disabled}
  >
    <FinanceCard title={title} description={description} padding="md">
      {status === 'planned' && <Planned>Planned</Planned>}
    </FinanceCard>
  </Button>
)

export default FinanceReportCard
